import { QueryClient, QueryKey } from '@tanstack/react-query';
import { SIMULATION_ENDPOINT_PREFIX } from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import { snakify } from 'helpers/syntaxHelper';
import { EnvelopeField } from './types';

const ENVELOPE_HISTORIC_DATA_API_KEY = 'envelope_historic_data';
const ENVELOPE_PREVIOUS_SIMULATION_DATA_API_KEY =
    'envelope_previous_simulation_data';

export const resetEnvelopeQueries = (queryClient: QueryClient) => {
    queryClient.resetQueries({ queryKey: [ENVELOPE_HISTORIC_DATA_API_KEY] });
    queryClient.resetQueries({
        queryKey: [ENVELOPE_PREVIOUS_SIMULATION_DATA_API_KEY],
    });
};

export const invalidateEnvelopeQueries = (queryClient: QueryClient) => {
    queryClient.invalidateQueries({
        queryKey: [ENVELOPE_HISTORIC_DATA_API_KEY],
    });
    queryClient.invalidateQueries({
        queryKey: [ENVELOPE_PREVIOUS_SIMULATION_DATA_API_KEY],
    });
};

export const getHrSimulationHistoricApiInfo = (
    simulationId: number,
    envelopeField: EnvelopeField,
): { apiCacheKey: QueryKey; endpoint: string } => ({
    apiCacheKey: [ENVELOPE_HISTORIC_DATA_API_KEY, simulationId, envelopeField],
    endpoint:
        `${SIMULATION_ENDPOINT_PREFIX}/${simulationId}/envelope_historic_data/${snakify(
            envelopeField,
        )}` as string,
});

export const getHrPreviousSimulationApiInfo = (
    simulationId: number,
    envelopeField: EnvelopeField,
): { apiCacheKey: QueryKey; endpoint: string } => ({
    apiCacheKey: [
        ENVELOPE_PREVIOUS_SIMULATION_DATA_API_KEY,
        simulationId,
        envelopeField,
    ],
    endpoint:
        `${SIMULATION_ENDPOINT_PREFIX}/${simulationId}/envelope_previous_simulation_data/${snakify(
            envelopeField,
        )}` as string,
});
